import {Injectable} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';

@Injectable()
export class AppService {
  public backGroundActive: string;
  public base: string;
  public visibleCookieBoolean: boolean;
  constructor(private cookieService: CookieService) {
    this.base = '';
    // COOKIE
    this.visibleCookieBoolean = !this.cookieService.get('acceptedCookies');
  }
  // COOKIE
  visibleCookieToogle() {
    this.visibleCookieBoolean = false;
    this.cookieService.set( 'acceptedCookies', String(this.visibleCookieBoolean));
  }
}


